'use strict';

/*global services*/

function K2AboutApp() {
  this.init();
}

K2AboutApp.prototype = $.extend({}, {
  constructor: 'K2AboutApp',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('.open-about-app').on('click', function () {
      _this.openAboutApp();

      return false;
    });
  },

  //----------------------------------------------------------------------------

  openAboutApp: function openAboutApp() {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
        height: 'auto',
        width: 'md',
        content: ''
      });

    modal.block();
    $.get(services.get('router').path('about_app'), function (res) {
      modal.unBlock();
      modal.content(res.data.html);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
